import { render, staticRenderFns } from "./WameedSwitch.vue?vue&type=template&id=11676e04&"
import script from "./WameedSwitch.vue?vue&type=script&lang=js&"
export * from "./WameedSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports